import CheckIcon from '@mui/icons-material/Check';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import {
  AVAILABILITY_DOT_COLOR,
  AVAILABILITY_STATUS,
} from 'constants/availabilityStatus';
import { useTranslation } from 'react-i18next';

const OPTIONS = [
  {
    value: AVAILABILITY_STATUS.AVAILABLE,
    labelKey: 'menu.available',
  },
  {
    value: AVAILABILITY_STATUS.UNAVAILABLE_TODAY,
    labelKey: 'menu.unavailable_for_today',
  },
  {
    value: AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE,
    labelKey: 'menu.unavailable_until_available',
  },
];

const menuItemSx = {
  justifyContent: 'space-between',
  py: 1.1,
  px: 2,
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: '#F5F5F5',
  },
  '&.Mui-selected, &.Mui-selected:hover, &.Mui-focusVisible': {
    backgroundColor: 'transparent',
  },
};

const StatusDot = ({ color }) => (
  <Box
    aria-hidden
    sx={{
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: color,
      flexShrink: 0,
    }}
  />
);

export default function AvailabilityDropdown({
  anchorEl,
  open,
  onClose,
  value,
  onSelect,
}) {
  const { t } = useTranslation();
  const selectedValue = value || AVAILABILITY_STATUS.AVAILABLE;

  const handleSelect = (event, status) => {
    event.stopPropagation();
    onSelect(status);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      MenuListProps={{
        'aria-label': t('menu.availability'),
        autoFocusItem: false,
        dense: true,
        sx: { py: 0.5 },
      }}
      PaperProps={{
        sx: {
          mt: 0.75,
          minWidth: 280,
          borderRadius: '8px',
          boxShadow: '0 8px 24px rgba(20, 20, 20, 0.12)',
        },
      }}
      onClick={(event) => event.stopPropagation()}
    >
      {OPTIONS.map((option) => {
        const isSelected = option.value === selectedValue;
        return (
          <MenuItem
            key={option.value}
            disableRipple
            onClick={(event) => handleSelect(event, option.value)}
            sx={menuItemSx}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StatusDot color={AVAILABILITY_DOT_COLOR[option.value]} />
              <Typography sx={{ fontSize: 14, color: '#141414' }}>
                {t(option.labelKey)}
              </Typography>
            </Box>
            {isSelected && (
              <CheckIcon sx={{ fontSize: 18, color: '#9E9E9E', ml: 2 }} />
            )}
          </MenuItem>
        );
      })}
    </Menu>
  );
}
